import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linebreak',
    standalone: false
})
export class LinebreakPipe implements PipeTransform {

  transform(value?: string): string {
    if (!value) return '';

    return value.replace(/(\r\n)/g, '<br>');
  }

}
